/**
 * Where an event's SMS log lives (SMS plugin wave, BE-5) and one manual send's
 * view of it (SMS manual send, F-4): `/event/:eventId/sms/sent-sms`, and the
 * same page with `?send=<jobId>` — that send's rows, skips and counts. The job
 * tray, the log's "Manual · …" source and the dialog's toast link here.
 */
export function smsSentPagePath(eventId: string): string {
  return `/event/${encodeURIComponent(eventId)}/sms/sent-sms`;
}

export function smsSendViewPath(eventId: string, jobId: string): string {
  return `${smsSentPagePath(eventId)}?send=${encodeURIComponent(jobId)}`;
}

/** The query parameter that opens the per-send view. */
export const SMS_SEND_VIEW_PARAM = "send";
